import Phaser from 'phaser';
import {
  ASSET_PATHS,
  PLAYER_SPRITE,
  SPRITE_KEYS,
  TILE_SIZE_PX,
  buildCreatureAssetList,
} from '@pokemiu/shared';

/**
 * Loads every asset in the registry then transitions to OverworldScene.
 *
 * The asset list is iterated from `@pokemiu/shared/assets` so client and
 * server agree on every key — a typo in either side fails the test
 * `assets-registry.test.ts` rather than 404'ing in the browser.
 */
const ASSET_BASE = `${import.meta.env.BASE_URL ?? '/'}assets`;
const STARTERS = ['treecko', 'torchic', 'mudkip'];

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    this.load.spritesheet(SPRITE_KEYS.player, `${ASSET_BASE}/${ASSET_PATHS.player}`, {
      frameWidth: PLAYER_SPRITE.frameWidth,
      frameHeight: PLAYER_SPRITE.frameHeight,
    });

    this.load.image(SPRITE_KEYS.tilesets.general, `${ASSET_BASE}/${ASSET_PATHS.tilesetGeneral}`);
    this.load.image(
      SPRITE_KEYS.tilesets.grassAnim,
      `${ASSET_BASE}/${ASSET_PATHS.tilesetGrassAnim}`,
    );

    this.load.tilemapTiledJSON(
      SPRITE_KEYS.maps.grassZone1,
      `${ASSET_BASE}/${ASSET_PATHS.mapGrassZone1}`,
    );

    for (const ref of buildCreatureAssetList(STARTERS)) {
      this.load.image(ref.key, `${ASSET_BASE}/${ref.path}`);
    }

    this.load.on('loaderror', (file: Phaser.Loader.File) => {
      console.error('[BootScene] asset load error:', file.src, file.key);
    });
  }

  create(): void {
    if (TILE_SIZE_PX !== 16) {
      console.warn('[BootScene] TILE_SIZE_PX !== 16 — OverworldScene may misrender');
    }
    this.scene.start('OverworldScene');
  }
}
